import { render, staticRenderFns } from "./InformacoesGeraisV2.vue?vue&type=template&id=1a46e030&scoped=true&lang=pug"
import script from "./InformacoesGeraisV2.vue?vue&type=script&lang=js"
export * from "./InformacoesGeraisV2.vue?vue&type=script&lang=js"
import style0 from "./InformacoesGeraisV2.vue?vue&type=style&index=0&id=1a46e030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a46e030",
  null
  
)

export default component.exports